import { isHeyaHost } from '@/app/theme/resolveTheme'
import '@/src/types/zohoSalesIq'
import { getCookie } from '@/src/utils/browser'

const SCRIPT_ID = 'zsiqscript'
const WIDGET_URL = 'https://salesiq.zohopublic.com/widget?wc='

const WIDGET_CODES = {
    CLEARTRIP: 'siq1b295f9a939f71a4db4fc65a2dfa70d2844ca88cd3d3de20dca4d430c1147f47',
    FLYIN_EG: 'siq288f4f88b75625e8b438e590ea47436a8343bcffe33b437a3aad5ccc7a72e266',
    FLYIN: 'siq3bd54a39540259e672bb6f3d976501674894701a632b93031160bb4527cabb0d',
    HEYA: 'siqdb62ecb8210e72fcb41efe01bd36c728'
}

// Tracks whether a page that wants the widget is mounted; the widget outlives soft navigation.
let isWidgetWanted = false

const getWidgetCode = (hostname: string): string => {
    if (isHeyaHost(hostname)) return WIDGET_CODES.HEYA
    if (hostname.includes('cleartrip')) return WIDGET_CODES.CLEARTRIP
    if (hostname.includes('eg.')) return WIDGET_CODES.FLYIN_EG
    return WIDGET_CODES.FLYIN
}

const setWidgetVisibility = (visible: boolean) => {
    const salesiq = window.$zoho?.salesiq
    salesiq?.floatbutton?.visible(visible ? 'show' : 'hide')
    if (!visible) salesiq?.floatwindow?.visible('hide')
}

const tagVisitor = () => {
    const visitor = window.$zoho?.salesiq?.visitor
    const authToken = getCookie('ct-auth')
    if (authToken) {
        visitor?.info({ 'ct-auth': decodeURIComponent(authToken) })
        visitor?.tag(['authenticated'])
    } else {
        visitor?.tag(['unauthenticated'])
    }
}

export const showZohoSalesIq = () => {
    isWidgetWanted = true
    if (document.getElementById(SCRIPT_ID)) {
        setWidgetVisibility(true)
        return
    }

    window.$zoho = window.$zoho || {}
    window.$zoho.salesiq = window.$zoho.salesiq || { ready: () => {} }
    window.$zoho.salesiq.ready = () => {
        // The user may have left the page while the widget was still loading.
        if (!isWidgetWanted) setWidgetVisibility(false)
        tagVisitor()
    }

    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.id = SCRIPT_ID
    script.defer = true
    script.src = `${WIDGET_URL}${getWidgetCode(window.location.hostname.toLowerCase())}`
    document.body.appendChild(script)
}

export const hideZohoSalesIq = () => {
    isWidgetWanted = false
    setWidgetVisibility(false)
}
